import axios from "axios";
import { MessageBox, Message, Loading } from "element-ui";
import { getToken } from '@/utils/auth'

// 创建axios实例
// const service = axios.create({
//   baseURL: "http://8.134.167.49/", // api base_url
//   timeout: 60 * 1000, // 请求超时时间
//   headers: { "Content-Type": "application/json" },
//   withCredentials: true,
//   crossDomain: true
// });

const service = axios.create({
  baseURL: "http://127.0.0.1:8084/", // 或者使用服务器IP "http://8.134.167.49:8084/"
  // baseURL: "http://localhost:8084/", // 或者使用服务器IP "http://8.134.167.49:8084/"
  timeout: 60 * 1000,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"  // 修正拼写错误：Mith → With
  },
  withCredentials: false,
  crossDomain: true
});


// 请求拦截器
// service.interceptors.request.use(
//   config => {
//     // 在发送请求之前做些什么
//     const token = getToken();
//     if (token) {
//       config.headers['Authorization'] = 'Bearer ' + token;
//     }
//     return config;
//   },
//   error => {
//     // 对请求错误做些什么
//     return Promise.reject(error);
//   }
// );

service.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
});


// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    if (response.status === 200) {
      return Promise.resolve(response.data); // 直接返回data部分
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        // 401: 未登录
        case 401:
          MessageBox.confirm(
            '登录状态已过期，请重新登录',
            '系统提示',
            {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            // 跳转到登录页
            window.location.href = '/login';
          });
          break;
        // 403 token过期
        case 403:
          Message({
            message: '拒绝访问',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        // 404请求不存在
        case 404:
          Message({
            message: '请求资源不存在',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        default:
          Message({
            message: error.response.data.message || '服务异常',
            type: 'error',
            duration: 5 * 1000
          });
      }
    } else {
      // 处理断网情况
      Message({
        message: '网络连接异常，请检查您的网络',
        type: 'error',
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 * @param {boolean} showLoading 是否显示loading
 */
export function get(url, params = {}, showLoading = false) {
  let loadingInstance;
  if (showLoading) {
    loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
      text: '加载中...'
    });
  }

  // 过滤空参数
  const filteredParams = {};
  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      filteredParams[key] = params[key];
    }
  });

  return new Promise((resolve, reject) => {
    service.get(url, { params: filteredParams })
      .then(response => {
        loadingInstance && loadingInstance.close();
        resolve(response);
      })
      .catch(error => {
        loadingInstance && loadingInstance.close();
        reject(error);
      });
  });
}

/**
 * 封装post方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 * @param {boolean} showLoading 是否显示loading
 */
export function post(url, params = {}, showLoading = false) {
  let loadingInstance;
  if (showLoading) {
    loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
      text: '提交中...'
    });
  }

  return new Promise((resolve, reject) => {
    service.post(url, params)
      .then(response => {
        loadingInstance && loadingInstance.close();
        resolve(response);
      })
      .catch(error => {
        loadingInstance && loadingInstance.close();
        reject(error);
      });
  });
}

/**
 * 封装put方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 */
export function put(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.put(url, params)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 封装delete方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 */
export function del(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.delete(url, { params })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

// 默认导出service实例
export default service;




// WEBPACK FOOTER //
// ./src/utils/request.js